import React, { useEffect, useState } from 'react';

const EMBEDDED_PLUGIN_URL = process.env.REACT_APP_EMBEDDED_PLUGIN_FRAME;

export default function RemixEmbedComponent(props) {
  const { currentIt } = props;
  const [embedPluginUrl, setEmbedPluginUrl] = useState(EMBEDDED_PLUGIN_URL);

  useEffect(() => {
    const host = window.location.host;
    if ((!host.includes('wwwt11') && !host.includes('localhost')) && host.includes('www')) {
      const currentUrl = embedPluginUrl;
      setEmbedPluginUrl(currentUrl.replace('https://', 'https://www.'))
    }
  }, [embedPluginUrl, setEmbedPluginUrl]);

  return (
    <iframe width="640" height="360" src={`${EMBEDDED_PLUGIN_URL}?remixid=${currentIt.rid}&nooverbottomstartag&noovertopstartag&refreshonrestartbtn`} title="PLUGIN iFrame" frameBorder="0"></iframe>
  );
}
